import { useEffect, useState } from 'react';

import { onUserAuth } from './firestore';
import { identify, track, ANALYTICS_EVENT } from './analytics';
import logger from './logger';
import getProjectConfig from './projectConfig/getProjectConfig';

export function useAnalyticsCommand(
  command: string,
  flags: Record<string, unknown> = {},
  properties: Record<string, unknown> = {},
) {
  const [hasAttemptedTracking, setTrackingAttempt] = useState(false);

  logger.info({ command, flags, properties }, 'useAnalyticsCommand');

  try {
    if (flags.projectPath) {
      properties = {
        ...properties,
        ...getProjectConfig(),
      };
    }
  } catch {
    // do nothing
  }

  useEffect(() => {
    const authUnsubscribe = onUserAuth(async (user) => {
      /**
       * Only identify if there's a user id (stops use of anon id).
       * Subsequent track callback will thus always be tied to a user.
       */
      if (user.uid) {
        identify(
          user.uid,
          {
            email: user.email,
            displayName: user.displayName,
          },
          () => {
            track(
              ANALYTICS_EVENT.CLI_COMMAND,
              {
                ...properties,
                flags,
                command,
              },
              () => setTrackingAttempt(true),
            );
            authUnsubscribe?.();
          },
        );
      }
    });

    // if it takes longer than 5 secs to identify a user, just set the
    // tracking attempt to true so that other commands aren't waiting
    // forever to terminate (see whoami component)
    setTimeout(() => setTrackingAttempt(true), 5000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // leave empty - this should only ever execute once (on mount)

  return { hasAttemptedTracking };
}
